/* eslint-disable no-underscore-dangle */

import { tap, pipe } from 'wonka';

const callback = (result) => {
  if (typeof window !== 'undefined' && window._QA_CALLBACK && typeof window._QA_CALLBACK === 'function') {
    window._QA_CALLBACK(result);
  }
  window._GQL_HISTORY ||= [];
  window._GQL_HISTORY.push(result);
};

/**
 * This is QA URQL Exchange to track GraphQL responses
 */
export const qaExchange = ({ forward }) => (ops$) => pipe(
  forward(ops$),
  tap(result => {
    callback(result);
  })
);
